import { createContext } from 'react';
export var CloseNotificationContext = createContext(null);
//# sourceMappingURL=CloseNotificationContext.js.map